import { FillButton, FillPreview, Tooltip } from "@wix/design-system";
import { RevertSmall } from "@wix/wix-ui-icons-common";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext, ZIndexContext } from "./../../../ricos-context";
import classes from "./color-swatches.scss";
import { ADD_CUSTOM_COLOR_BUTTON, RESET_COLOR_BUTTON, SWATCH, SWATCHES } from "./data-hooks";
const ColorSwatches = ({
  userColors,
  selectedColor,
  onAddClick,
  onChange,
  size = "small",
  allowEmpty,
  showResetButton
}) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(classes.container, {
        [classes.medium]: size === "medium"
      }),
      "data-hook": SWATCHES
    },
    showResetButton && /* @__PURE__ */ React.createElement(
      FillButton,
      {
        icon: /* @__PURE__ */ React.createElement(RevertSmall, null),
        iconSize: "medium",
        onClick: () => onChange(void 0),
        dataHook: RESET_COLOR_BUTTON,
        tooltipContent: t("ColorPickerResetColor_Tooltip"),
        tooltipProps: {
          appendTo: (el) => {
            var _a;
            return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
          },
          zIndex: zIndexService.getZIndex("TOOLTIP")
        }
      }
    ),
    /* @__PURE__ */ React.createElement(
      FillButton,
      {
        iconSize: "medium",
        onClick: onAddClick,
        dataHook: ADD_CUSTOM_COLOR_BUTTON,
        tooltipContent: t("ColorPickerAddCustomColor_Tooltip"),
        tooltipProps: {
          appendTo: (el) => {
            var _a;
            return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
          },
          zIndex: zIndexService.getZIndex("TOOLTIP")
        }
      }
    ),
    allowEmpty && /* @__PURE__ */ React.createElement(EmptyColorSwatch, { onClick: onChange, selected: selectedColor === void 0 }),
    userColors.map((userColor) => /* @__PURE__ */ React.createElement(
      ColorSwatch,
      {
        key: userColor,
        fill: userColor,
        selectedColor,
        onClick: onChange
      }
    ))
  );
};
const ColorSwatch = ({ fill, selectedColor, onClick }) => {
  return /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      appendTo: (el) => {
        var _a;
        return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
      },
      content: fill,
      dataHook: "color-swatch-tooltip"
    },
    /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        className: classes.colorSwatch,
        selected: selectedColor === fill,
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick(fill);
        },
        fill,
        dataHook: SWATCH
      }
    )
  );
};
const EmptyColorSwatch = ({
  onClick,
  selected
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      appendTo: (el) => {
        var _a;
        return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
      },
      content: t("ColorPicker_RemoveColor_Tooltip"),
      dataHook: "color-swatch-tooltip"
    },
    /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        className: classes.colorSwatch,
        onClick: () => onClick(void 0),
        selected,
        dataHook: SWATCH
      }
    )
  );
};
export {
  ColorSwatches
};
//# sourceMappingURL=color-swatches.js.map
